import { Card, CardContent } from "../../client/components/ui/card";
import { CardSectionHeader } from "../../client/components/ui/card-section-header";
import AnimatedMetric from "../../client/components/AnimatedMetric";
import { useDashboardData } from "./DashboardDataContext";

export default function ProfitFactorWidget() {
  const { metrics, isDark, t } = useDashboardData();
  if (!metrics) return null;
  return (
    <Card className="h-full flex flex-col">
      <CardSectionHeader label={t.dashboard.profitFactorLabel} isDark={isDark} compact />
      <CardContent className="px-4 pb-4 pt-2 flex-1 flex flex-col justify-center min-w-0">
        <AnimatedMetric value={metrics.profitFactor} format="decimal" className="block truncate text-xl sm:text-2xl font-bold font-mono tabular-nums" />
        <div className="mt-1.5 truncate text-xs text-muted-foreground">
          {metrics.averageWin.toFixed(2)} $ / {metrics.averageLoss.toFixed(2)} $
        </div>
      </CardContent>
    </Card>
  );
}
